import React from 'react';
import { MapPin } from 'lucide-react';
import GooglePlacesAutocomplete from '../../../components/GooglePlacesAutocomplete';

const LocationStep = ({ formData, errors, handleInputChange, handlePlaceSelected }) => {
    return (
        <div className="form-section">
            <h3>
                <MapPin size={24} />
                Location
            </h3>
            <p>Where is your venue located? Search for a place or enter the address manually.</p>

            <div className="form-field required full-width">
                <label>Search Address</label>
                <div style={{ position: 'relative', zIndex: 1000 }}>
                    <GooglePlacesAutocomplete
                        onPlaceSelect={handlePlaceSelected}
                        value={formData.formattedAddress}
                        onChange={(e) => handleInputChange('formattedAddress', e.target.value)}
                        placeholder="Search for a venue or address..."
                    />
                </div>
            </div>

            <div className="form-grid">
                <div className="form-field required">
                    <label>Street Address</label>
                    <input
                        type="text"
                        className={`wizard-input ${errors.street ? 'error' : ''}`}
                        value={formData.street}
                        onChange={(e) => handleInputChange('street', e.target.value)}
                        placeholder="123 Main St"
                    />
                    {errors.street && <div className="error-message">{errors.street}</div>}
                </div>

                <div className="form-field required">
                    <label>City</label>
                    <input
                        type="text"
                        className={`wizard-input ${errors.city ? 'error' : ''}`}
                        value={formData.city}
                        onChange={(e) => handleInputChange('city', e.target.value)}
                        placeholder="New York"
                    />
                    {errors.city && <div className="error-message">{errors.city}</div>}
                </div>
            </div>

            <div className="form-grid">
                <div className="form-field required">
                    <label>State / Province</label>
                    <input
                        type="text"
                        className={`wizard-input ${errors.state ? 'error' : ''}`}
                        value={formData.state}
                        onChange={(e) => handleInputChange('state', e.target.value)}
                        placeholder="NY"
                    />
                    {errors.state && <div className="error-message">{errors.state}</div>}
                </div>

                <div className="form-field required">
                    <label>Country</label>
                    <input
                        type="text"
                        className={`wizard-input ${errors.country ? 'error' : ''}`}
                        value={formData.country}
                        onChange={(e) => handleInputChange('country', e.target.value)}
                        placeholder="United States"
                    />
                    {errors.country && <div className="error-message">{errors.country}</div>}
                </div>

                <div className="form-field">
                    <label>Zip / Postal Code</label>
                    <input
                        type="text"
                        className={`wizard-input ${errors.zipCode ? 'error' : ''}`}
                        value={formData.zipCode}
                        onChange={(e) => handleInputChange('zipCode', e.target.value)}
                        placeholder="10001"
                    />
                </div>
            </div>
        </div>
    );
};

export default LocationStep;
